import axiosInstance from '../axiosInstance';
import { requestResources } from '../requestResources';
import { IResponse } from '../types';
import { ITicket, ITicketFilterOptions, ITicketNote, IGetTicketParams } from './types';
import { ICreateTicketFormInitialValues, ICreateTicketNote } from '../../pages/Tickets/types';

const { clientPortalTickets, clientPortalConfig } = requestResources;

export const getTickets = (params: IGetTicketParams): IResponse<ITicket[]> =>
  axiosInstance.get(`${clientPortalTickets}`, { params });

export const getTicketNotes = (ticketId: string | number): IResponse<ITicketNote[]> =>
  axiosInstance.get(`${clientPortalTickets}/${ticketId}/notes?_order=1`);

export const createTicket = (
  payload: ICreateTicketFormInitialValues,
): IResponse<{ data: string }> => axiosInstance.post(`${clientPortalTickets}`, payload);

export const getTicket = (ticketId: string): IResponse<ITicket> =>
  axiosInstance.get(`${clientPortalTickets}/${ticketId}`);

export const createTicketNote = (
  ticketId: string,
  payload: ICreateTicketNote,
): IResponse<ITicketNote> =>
  axiosInstance.post(`${clientPortalTickets}/${ticketId}/notes`, payload);

export const getTicketOptions = (): IResponse<ITicketFilterOptions> =>
  axiosInstance.get(`${clientPortalConfig}/ticketOptions`);
